const catiaCaaCourse = {
    id: "catia-caa",
    name: "CATIA Automation & Customization",
syllabusPdf: "/syllabus/CATIA-CAA-RADE-Syllabus.pdf",

    hero: {
        title: "CATIA Automation & Customization",
        subtitle: "Live & Interactive Online Training",
        logo: "/catia-2.webp",

        points: [
            "Master CATIA automation and customization using C++. Learn to control CATIA programmatically to automate part modeling, assemblies, and drawing creation through CATIA’s CAA RADE (Component Application Architecture).",

            "Ideal for engineers and CAD professionals who want to unlock high-paying roles and rapid career growth by mastering CATIA C++ development.",

            "Gain the skills required to shift from traditional design work to advanced automation and application development inside CATIA using the powerful CAA framework.",

            "Start from core C++ programming concepts, so even those with limited coding experience can confidently move into CATIA customization.",

            "Get hands-on training and mentorship from industry experts currently working in CATIA automation and PLM environments across top-tier companies."
        ]
    },

    highlights: [
        {
            title: "High Salary",
            description:
                "CATIA Design Engineers with 4 to 5 years of experience typically earn a CTC between ₹5 lakh and ₹10 lakh. In contrast, CATIA Developers with similar experience can secure salaries ranging from ₹20 lakh to ₹40 lakh."
        },
        {
            title: "Good Demand",
            description:
                "While CATIA Design is a well-known skill among mechanical engineers, there is intense competition for design jobs. On the other hand, CATIA Automation & Customization is a niche expertise, with only a few engineers."
        },
        {
            title: "Easier To Learn",
            description:
                "While CATIA Design is generally easier to learn, CATIA Automation & Customization can be more challenging. With our extensive experience in this field, we aim to simplify the process for you with our step by step training."
        }
    ],

    whyLearn: [
        {
            title: "High-Demand Skill Across Industries",
            description:
                "CATIA is the industry standard in aerospace, automotive, and manufacturing. Companies seek professionals who can automate design workflows and extend CATIA functionality."
        },
        {
            title: "Automate Complex & Repetitive Tasks",
            description:
                "Eliminate manual modeling by writing scripts and tools to automate part creation, assembly constraints, and drawing generation."
        },
        {
            title: "Unlock High-Paying Roles",
            description:
                "Automation specialists and CATIA developers earn significantly more than traditional CAD designers due to their technical skill set."
        },
        {
            title: "Accelerate Your Career Growth",
            description:
                "Move beyond routine design roles into strategic positions such as CAD Developer, Automation Engineer, or PLM Solution Architect."
        },
        {
            title: "Learn Real Programming with Real Results",
            description:
                "Apply C, C++, or VB to solve real engineering problems — making programming easier to understand and more rewarding."
        },
        {
            title: "Create Custom Design Tools",
            description:
                "Build specialized applications that suit your company’s unique processes, saving time and improving accuracy."
        },
        {
            title: "Work with Global OEMs & Tier-1 Suppliers",
            description:
                "CATIA is used by top companies like Airbus, Boeing, BMW, and Mahindra — automation skills make you globally employable."
        },
        {
            title: "Integrate with PLM & Enterprise Systems",
            description:
                "Automate CATIA as part of broader digital workflows — connecting with tools like ENOVIA, Teamcenter, or custom ERP systems."
        },
        {
            title: "Future-Proof Your Engineering Career",
            description:
                "As the industry shifts toward intelligent design and digital twins, automation will be a key skill that sets you apart"
        },
        {
            title: "Get Mentorship from Experts",
            description:
                "Learn directly from professionals working on CATIA automation in real projects, with hands-on guidance and career support."
        }
    ],

    syllabus: [
        {
            name: "C++",
            modules: [
                {
                    number: 1,
                    title: "Basic C++ Concepts",
                    topics: [
                        "Introduction to C++",
                        "OOPS Basic Concepts",
                        "Basic Syntax and Structure",
                        "Data Types and Modifiers",
                        "Variables in C++",
                        "Operators in C++",
                        "sizeof and typedef in C++",
                        "Decision Making (if, switch)",
                        "Loop Types (for, while, do-while)",
                        "Storage Classes",
                        "Functions in C++"
                    ]
                },
                {
                    number: 2,
                    title: "Object-Oriented Programming (OOP) in C++",
                    topics: [
                        "Classes and Objects",
                        "Access Controls in Classes (public, private, protected)",
                        "Defining Class and Object",
                        "Accessing Data Members",
                        "Member Functions in Class",
                        "Types of Member Functions",
                        "Inline Functions",
                        "Function Overloading",
                        "Constructor and Destructor",
                        "Initializer List",
                        "Namespace",
                        "static Keyword",
                        "const Keyword",
                        "References",
                        "Copy Constructor",
                        "Pointer to Members"
                    ]
                },
                {
                    number: 3,
                    title: "Advanced C++ Concepts",
                    topics: [
                        "Introduction to Inheritance",
                        "Types of Inheritance (Single, Multiple, Multilevel, Hierarchical, Hybrid)",
                        "Order of Constructor Calls",
                        "Upcasting",
                        "Function Overriding",
                        "Virtual Functions",
                        "Abstract Classes & Pure Virtual Functions",
                        "Virtual Destructors",
                        "Operator Overloading",
                        "File Streams (ifstream, ofstream, fstream)",
                        "Exception Handling",
                        "Memory Management (new, delete)",
                        "Multithreading (Basics using <thread>)"
                    ]
                },
                {
                    number: 4,
                    title: "C++ Miscellaneous Topics",
                    topics: [
                        "Namespaces",
                        "String Handling (std::string)",
                        "Exception Handling (try/catch blocks)",
                        "User-Defined Types",
                        "Templates (Function & Class Templates)",
                        "Signal Handling",
                        "File & Stream Operations",
                        "getline() Usage"
                    ]
                }
            ]
        },

        {
            name: "CATIA CAA",
            modules: [
                {
                    number: 1,
                    title: "C++ Fundamentals",
                    topics: [
                        "Object-Oriented Programming (OOPS)",
                        "Classes & Objects",
                        "Inheritance & Polymorphism",
                        "Data Types",
                        "Conditional Statements",
                        "Looping Constructs",
                        "Pointers & References",
                        "Methods (Member Functions)"
                    ]
                },
                {
                    number: 2,
                    title: "COM Notations",
                    topics: [
                        "Dynamic Linking",
                        "Exporting & Managing Object Lifetime",
                        "Extending COM Objects",
                        "Understanding IUnknown",
                        "Using Smart Pointers",
                        "Working with HRESULT"
                    ]
                },
                {
                    number: 3,
                    title: "Development Architecture",
                    topics: [
                        "One Technological Choice (OTC) Principle",
                        "CAA Solution Architecture Overview",
                        "CAA Development Tools Basics"
                    ]
                },
                {
                    number: 4,
                    title: "Object Modeler",
                    topics: [
                        "Object Modeler Overview",
                        "Interface / Implementation Design Pattern",
                        "Linking Interface & Implementation",
                        "Extension Mechanism",
                        "Late Typing",
                        "Object Life Cycle",
                        "Smart Pointer Usage",
                        "CAA Coding Rules"
                    ]
                },
                {
                    number: 5,
                    title: "Application Frame",
                    topics: [
                        "CATIA V5 Frame Editor",
                        "Workshop & Workbench Structure",
                        "Addin Integration"
                    ]
                },
                {
                    number: 6,
                    title: "User Interaction (UI)",
                    topics: [
                        "Command Structure",
                        "Dialog Object Creation",
                        "Layout Management",
                        "Command/Dialog Integration",
                        "Resource Management (NLS, ICONs, etc.)"
                    ]
                },
                {
                    number: 7,
                    title: "Product Structure & Assembly",
                    topics: [
                        "Product Component",
                        "Connectors",
                        "Publications",
                        "Constraints"
                    ]
                },
                {
                    number: 8,
                    title: "Specification Modeler",
                    topics: [
                        "Purpose of Specifications",
                        "Spec Modeler Objectives",
                        "Feature-Based Architecture",
                        "CATIA Document Structure"
                    ]
                },
                {
                    number: 9,
                    title: "Mechanical Modeler",
                    topics: [
                        "Objectives of Mechanical Modeling",
                        "Related Frameworks",
                        "Working with CATPart Documents",
                        "Creating Mechanical Features"
                    ]
                },
                {
                    number: 10,
                    title: "Knowledgeware Integration",
                    topics: [
                        "Knowledgeware Overview",
                        "Literal Features",
                        "Creating Relations (Formulae & Rules)"
                    ]
                }
            ]
        }
    ],

    videos: [
        {
            category: "What is CAD Customization? ( Explained using real project)",
            title: "CAD Customization And Automation Session",
            videoUrl:
                "https://www.youtube.com/embed/VpcpMwvQJy4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=1&forigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fnx-open-customization-automation-training%2F&vf=1"
        },
        {
            category: "Python CATIA Demo video",
            title: "CornerRelief Python CATIA V5",
            videoUrl:
                "https://www.youtube.com/embed/gsO-5-ElME4?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=3&forigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fnx-open-customization-automation-training%2F&vf=1"
        },
        {
            category: "Hole Feature Color Python",
            title: "HoleFeatureColor Python",
            videoUrl:
                "https://www.youtube.com/embed/O81-1Yxr_Sk?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=5&forigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fnx-open-customization-automation-training%2F&vf=1"
        },
        {
            category: "Part List Python",
            title: "PartList Python",
            videoUrl:
                "https://www.youtube.com/embed/yviOzMPOiFI?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=7&forigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fnx-open-customization-automation-training%2F&vf=1"
        },
        {
            category: "HighlightFilletFaces",
            title: "HighlightFilletFaces",
            videoUrl:
                "https://www.youtube.com/embed/ge93PJa5t8g?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=9&forigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fnx-open-customization-automation-training%2F&vf=1"
        },
        {
            category: "CreateLine Python",
            title: "CreateLine Python",
            videoUrl:
                "https://www.youtube.com/embed/fewg-QgHMWY?controls=1&rel=0&playsinline=0&cc_load_policy=0&autoplay=0&enablejsapi=1&origin=https%3A%2F%2Ffeesworth.com&widgetid=11&forigin=https%3A%2F%2Ffeesworth.com%2Fcatia-caa-customization-automation-training%2F&aoriginsup=1&gporigin=https%3A%2F%2Ffeesworth.com%2Fnx-open-customization-automation-training%2F&vf=1"
        }
    ],

    faq: [
        {
            question: "What is CATIA CAA?",
            answer:
                "CATIA CAA is a development platform for Dassault Systèmes’ CATIA software. It allows users to create custom applications, automate design and engineering tasks, and perform in-depth analyses within CATIA, enabling tailored solutions to meet specific industry and project requirements."
        },
        {
            question: "How Much Salary?",
            answer: [
                "CATIA Developers often receive significantly higher salaries compared to CATIA 3D designers. This is because they create automation tools that can perform tasks that would be challenging for many individuals to accomplish without such tools.",

                "For a detailed explanation, please view the video located at this page."
            ]
        },
        {
            question: "I Have CATIA CAA Design Experience",
            answer: [
                "Having CATIA design experience is an advantage. It allows you to fully leverage your design skills and familiarity with CATIA tools.",

                "You can adeptly assess and make informed decisions about which aspects to automate and the value that automation brings.",

                "In the future, your background can position you to lead teams of both design engineers and developers, bridging the gap between design excellence and cutting-edge automation solutions."
            ]
        },
        {
            question: "Job Guaranteed?",
            answer: [
                "We provide only Training and Job Assistance and not Job Guarantee.",

                "In some special cases Job guaranteed training is possible. Please speak to the coordinator."
            ]
        },
        {
            question: "Which Programming Language?",
            answer:
                "CATIA can be customized using VBA, .NET and C++ and CAA. While VBA and .NET customization are free, CAA need special License."
        },
        {
            question: "Job Opportunities?",
            answer:
                "This skill is quite rare, with a limited number of professionals available in the market compared to the growing demand. Consequently, the job opportunities in this field are in high demand and offer promising prospects."
        }
    ]
};

export default catiaCaaCourse;